<template>
  <div>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <base-list-management ref="baseListManagement" :configData.sync="configData">
      <template slot="custom-operate">
        <el-button
          v-if="judgePermission('company_handle_store')"
          type="primary"
          size="small"
          @click="handleAddStore"
        >新增门店</el-button>
      </template>
    </base-list-management>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import configData from '../config/list'

export default {
  data() {
    return {
      configData: configData.call(this),
      handleDialogInfo: {
        // eslint-disable-next-line vue/no-unused-properties
        data: {},
      },
    }
  },
  methods: {
    // 跳转门店详情
    // eslint-disable-next-line vue/no-unused-properties
    handleToStoreDetail(row) {
      this.$router.push({
        path: '/companyNew/company/storeManage/detail',
        query: { id: row.id },
      })
    },
    // 处理搜索参数
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      const params = val
      if (params.createTime) {
        params.createTimeStart = val.createTime[0]
        params.createTimeEnd = val.createTime[1]
      }
      delete params.createTime
      return params
    },
    // 添加门店
    handleAddStore() {
      this.$router.push({
        path: '/companyNew/company/storeManage/add',
      })
      this.handleDialogInfo = {
        data: {},
      }
    },
    // 编辑门店
    // eslint-disable-next-line vue/no-unused-properties
    handleEditStore(row) {
      this.$router.push({
        path: '/companyNew/company/storeManage/add',
        query: {
          id: row.id,
        },
      })
    },
    // 点击Id 查看详情
    // eslint-disable-next-line vue/no-unused-properties
    lookStoreDetail(row) {
      this.$refs.StoreInfoRef.show = true
      this.handleDialogInfo = {
        data: row,
      }
    },
  },
}
</script>
